
import CurrencyConverter from "../common/currency-converter.vue";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel, CurrencyConverter },
  data() {
    return {
      items: [
        { dishType: "veg", itemName: "Veg Soup", amount: "396.00" },
        { dishType: "veg", itemName: "Mushroom Soup", amount: "396.00" },
        { dishType: "veg", itemName: "Avial", amount: "396.00" },
        { dishType: "veg", itemName: "Masala Dosa", amount: "396.00" },
        { dishType: "veg", itemName: "Uthappam", amount: "396.00" }
      ]
    };
  }
};
